import React from 'react'
import './skelton.scss'
type AppProps={
    type:string;
}

const SkeltonElement = ({type}:AppProps) => {
    const classes = `skeleton ${type}`
  return (
    <div className={classes}>
    </div>
  )
}

export default SkeltonElement